<main class="table-page table-page--fill vazir" dir="rtl">
  <header class="header">
    <div class="title-row">
      <button class="back" type="button" aria-label="بازگشت" routerLink="/">
        <i class="fa fa-arrow-right" aria-hidden="true"></i>
      </button>
      <div class="title-block">
        <h1 class="title">موقعیت خودروها در زمان</h1>
        <span class="muted" *ngIf="resultDate">{{ resultDate | faNum }} · ساعت {{ resultTime | faNum }}</span>
      </div>
      <div class="actions">
        <button class="btn btn-ghost" type="button" [disabled]="loading" [attr.aria-expanded]="filtersOpen"
          aria-controls="timelineFilters" (click)="filtersOpen = !filtersOpen">
          <i class="fa fa-sliders" aria-hidden="true"></i> فیلتر
          <i class="fa fa-chevron-down chev" aria-hidden="true"></i>
        </button>
        <span class="actions-sep"></span>
        <button class="btn btn-ghost" type="button" [disabled]="loading || hasError || !allCar.length" (click)="fitMap()">
          <i class="fa fa-arrows-alt" aria-hidden="true"></i> نمایش همه روی نقشه
        </button>
      </div>
    </div>
    <div class="collapsible" id="timelineFilters" [class.collapsed]="!filtersOpen">
      <div class="collapsible-inner">
        <form class="filters" [formGroup]="mdl_Search" (ngSubmit)="search_Timeline()">
          <fieldset class="field border-0 p-0 m-0" [disabled]="loading">
            <label class="field-label" for="timelineDate">تاریخ</label>
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateInitValue]="false"
              [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'"
              [uiHideAfterSelectDate]="true" [uiHideOnOutsideClick]="true">
              <input id="timelineDate" class="control" type="text" formControlName="strDate"
                placeholder="تاریخ را انتخاب کنید" readonly />
            </ng-persian-datepicker>
          </fieldset>
          <fieldset class="field border-0 p-0 m-0" [disabled]="loading">
            <label class="field-label" for="timelineTime">ساعت</label>
            <div class="input-group clockpicker" #timePicker>
              <input id="timelineTime" class="control" type="text" formControlName="strTime"
                placeholder="ساعت را مشخص کنید" autocomplete="off" required />
              <span class="input-group-addon"><span class="glyphicon glyphicon-time"></span></span>
            </div>
          </fieldset>
          <div class="filter-actions">
            <button class="btn btn-primary" type="submit" [disabled]="loading">
              <i class="fa fa-search" aria-hidden="true"></i> جستجو
            </button>
          </div>
        </form>
      </div>
    </div>
  </header>

  <div class="body flex-row-reverse">
    <div class="col-8 d-flex ps-2">
  <section class="card" aria-label="موقعیت خودروها روی نقشه">
    <div class="body" #mapTarget tabindex="0" aria-label="نقشه موقعیت خودروها"></div>
    <div class="position-absolute" id="map_tooltip" data-bs-html="true"></div>
    <div class="position-absolute" id="map_tooltips" data-bs-html="true"></div>
  </section>
    </div>
    <div class="col-4 d-flex pe-2">
  <section class="card" aria-label="فهرست موقعیت خودروها">
    <div class="table-toolbar">
      <div class="search-wrap">
        <input class="control" type="search" aria-label="جستجو در جدول خودروها"
          placeholder="جستجو در جدول: راننده، موبایل، ساعت..."
          [disabled]="loading || !hasSearched || hasError" [(ngModel)]="searchText" (ngModelChange)="filterVehicles()" />
        <i class="fa fa-search" aria-hidden="true"></i>
      </div>
    </div>
    <div class="body" [attr.aria-busy]="loading">
      <div class="loader" [class.show]="loading" role="status" aria-live="polite">
        <div class="spinner"></div><span>در حال دریافت اطلاعات…</span>
      </div>
      <div class="state" id="stEmpty" [class.show]="!loading && !hasError && !allCar.length">
        <div class="ico-big"><i class="fa fa-map-marker" aria-hidden="true"></i></div>
        <h4>{{ !hasSearched ? 'تاریخ و ساعت را انتخاب کنید' : searchText.trim() ? 'با این فیلترها نتیجه‌ای پیدا نشد!' : 'اطلاعاتی برای این تاریخ و ساعت وجود ندارد' }}</h4>
        <span class="muted" *ngIf="!hasSearched">برای نمایش موقعیت خودروها، فیلترها را تکمیل و جستجو کنید.</span>
        <div class="empty-actions" *ngIf="searchText.trim()">
          <button class="btn btn-ghost" type="button" (click)="searchText = ''; filterVehicles()">
            <i class="fa fa-undo" aria-hidden="true"></i> حذف جستجو
          </button>
        </div>
      </div>
      <div class="state error" id="stError" [class.show]="!loading && hasError" role="alert">
        <div class="ico-big"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div>
        <h4>دریافت اطلاعات با خطا مواجه شد</h4>
        <span class="muted">{{ errorMessage }}</span>
        <button class="btn btn-primary retry" type="button" (click)="search_Timeline()" [disabled]="loading">
          <i class="fa fa-refresh" aria-hidden="true"></i> تلاش مجدد
        </button>
      </div>
      <div class="table-scroll" id="tableWrap" (scroll)="tooltip.hide()">
        <table aria-label="موقعیت خودروها">
          <thead id="thead">
            <tr>
              <th class="col-ops sticky-first">عملیات</th>
              <th class="col-num">ردیف</th>
              <th>راننده</th>
              <th>موبایل</th>
              <th>ساعت</th>
            </tr>
          </thead>
          <tbody id="tbody">
            <tr *ngFor="let item of pagedRows; let i = index; trackBy: trackByVehicle" (click)="focusOnCar(item)">
              <td class="col-ops sticky-first">
                <div class="row-ops">
                  <button class="ico" type="button" aria-label="نمایش موقعیت روی نقشه"
                    [disabled]="loading || !item.fLon || !item.fLat"
                    (click)="$event.stopPropagation(); tooltip.hide(); focusOnCar(item)"
                    (mouseenter)="tooltip.show($event, 'نمایش موقعیت روی نقشه')" (mouseleave)="tooltip.hide()"
                    (focus)="tooltip.show($event, 'نمایش موقعیت روی نقشه')" (blur)="tooltip.hide()">
                    <i class="fa fa-map-marker" aria-hidden="true"></i>
                  </button>
                </div>
              </td>
              <td class="col-num">{{ (currentPage - 1) * pageSize + i + 1 | faNum }}</td>
              <td>{{ item.strFullName | faNum }}</td>
              <td>{{ item.strMobile | faNum }}</td>
              <td>{{ item.strTime | faNum }}</td>
            </tr>
          </tbody>
          <tfoot *ngIf="!loading && !hasError && allCar.length">
            <tr><td class="sticky-first"></td><td class="label" colspan="4">تعداد کل: {{ allCar.length | number | faNum }}</td></tr>
          </tfoot>
        </table>
      </div>
    </div>
    <app-table-pagination [page]="currentPage" [pageSize]="pageSize" [totalItems]="allCar.length"
      (pageChange)="changePage($event)" (pageSizeChange)="changePageSize($event)">
    </app-table-pagination>
  </section>
    </div>
  </div>
  <app-table-tooltip #tooltip></app-table-tooltip>
</main>
